import React, { useEffect} from 'react'
import { useDispatch, useSelector } from 'react-redux';
import {  Typography} from '@material-ui/core' 
import { ToastContainer, toast } from 'react-toastify';
import { getPurpose } from '../store/actions/CommonAction';
import { TimeoutLogic } from "../utils/TimeoutLogic";


const PurposeList = (props) => {

    const dispatch = useDispatch();

    const getPurposeList = useSelector(state => state.common.getPurposeList)
    const getProductTheme = useSelector(state => state.common.getProductTheme)

    const callAPI = async() =>{
        await dispatch(getPurpose())
    }
  //   const applyTheme = ()=>{
  //     document.getElementById("menuBar").style.setProperty('background-color', getProductTheme.theme, 'important');
        
  //       const consentCard = document.getElementsByClassName("consent-card");
  //       for (let i = 0; i < consentCard.length; i++) {
  //         consentCard[i].style.setProperty('border-top','4px solid '+getProductTheme.theme, 'important')
  //       }
  
  //       const cardHeader = document.getElementsByClassName("card-header");
  //       for (let i = 0; i < cardHeader.length; i++) {
  //         cardHeader[i].style.setProperty('color',getProductTheme.theme, 'important')
  //       }
     
  //       const dashboardCard = document.getElementsByClassName("dashboard-card");
  //       for (let i = 0; i < dashboardCard.length; i++) {
  //         dashboardCard[i].style.setProperty('border-top','4px solid '+getProductTheme.theme, 'important')
  //       }

  
  //       const th = document.getElementsByTagName("th");
  //       for (let i = 0; i < th.length; i++) {
  //         th[i].style.setProperty('color', getProductTheme.theme, 'important')
  //       }
  
  // }
  // eslint-disable-next-line
    useEffect(() => {callAPI();
    // applyTheme();
    }, [])

    useEffect(() => {
      if(!sessionStorage.getItem('sessionId')){
        toast.error(`Your Session has Expired: Please login again`);
        window.location.href = '/login';
    }
      // Add body class when component mounts
      document.body.classList.add('manage');
      // Remove body class when component unmounts
      return () => {
        document.body.classList.remove('manage');
      };
    }, []);
   
    return (
      <>   
      {/* <section className='content-header'>
        <div className='container'>
          <div className='row align-items-center'>
            <div className='col-md-12'>
              <h1 className='page-title'>
                Manage List of Purpose
                <span>We will help you to manage purpose.</span>
              </h1>
            </div>
          </div>
        </div>
      </section> */}

        { 
            getPurposeList && getPurposeList.length === 0  ?
            <div className=" center justify-content-center align-content-center p-2 m-2" >
                <Typography align="center" style={{ fontSize:20}}>No purposes available. </Typography>
            </div>
        :

        <section className='content h-100'>
        <div className='container' style={{marginTop:'10%'}}>
          <div className='row'>
            <div className='col-md-12'>
              <div class="card custom-cards">
                <div class="card-body">
                  <div className='row'>
                    <div className='col-md-12'>
                      <div className='table-responsive'>
                        <table class='table'>
                          <thead>
                            <tr>
                              <th scope='col'>S. No.</th>
                              <th scope='col'>Purpose Name</th>
                              <th scope='col'>Purpose Description</th>
                            </tr>
                          </thead>
                          <tbody>
                          { getPurposeList &&   getPurposeList.length > 0 &&
                              getPurposeList.map((element,key)=>(
                                <tr key={key} >
                                  <td>{key+1}</td>
                                  <td >{element.purpose}</td>
                                  <td >{element.purposeDesc}</td>
                                </tr>
                              ))  
                          }
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div className='row mt-2 justify-content-between'>
                    <div className='col-md-auto me-auto '>
                        <div className='dt-info'>
                        {getPurposeList &&
                          getPurposeList.length > 0 ? (
                            <div className="dt-info">
                              Showing 1 to {getPurposeList.length} entries of {getPurposeList.length} entries
                            </div>
                          ) : (
                            <div>
                              {getPurposeList && getPurposeList 
                                ? `${getPurposeList.length} entries present`
                                : "No entries present"}
                            </div>
                          )}
                        </div>
                    </div>
                    
                  </div>
                </div>
              </div>
            </div>
          </div>
          
        </div>
      </section>
      
      }

         {/* {getPurposeList &&  getPurposeList.length === 0 &&
                <Typography align="center" style={{ fontSize:20}}>No purposes available. </Typography>
        } */}

        
        
      

        <TimeoutLogic/>
        </>   
     )
}

export default PurposeList




//   { getPurposeList &&  
//     getPurposeList.map((ele, key) => ( 
    
//         <div key={key} className="innerItem m-2 p-2 " style={{display:'flex',justifyContent:'space-between'}}>   
//         <div>
//             <div>
//                 {/* <span>Purpose Id : </span>   <span style={{fontWeight:"bold"}}>{ele.purposeCode} </span> | */}
//                 <span>  Purpose: </span>   <span style={{fontWeight:"bold"}}>{ele.purpose}   </span> 
//             </div>
//             <div>
//                 <span> Purpose Description: </span>  <span style={{fontWeight:"bold"}}>{ele.purposeDesc} </span>
//                 {/* <span>Client Id : </span>  <span style={{fontWeight:"bold"}}>{ele.clientId} </span> */}
//             </div>
//         </div>        
       
//     </div>
   
//     ))
    